import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { cn } from '@/utils/classname';

interface Props extends PropsWithChildren {
  rounded?: boolean;
  className?: string;
  isLoading?: boolean;
  styleType?: 'header';
  type?: 'spinner';
}

export const Loader: React.FC<Props> = ({
  rounded,
  className,
  isLoading,
  children,
  type,
}: Props) => {
  const styleClasses = 'bg-chariot-stroke';

  if (isLoading) {
    if (type === 'spinner') {
      return (
        <div
          data-testid="loader"
          role="status"
          onClick={e => e.stopPropagation()}
          className={cn(
            'flex size-full items-center justify-center',
            'text-chariot-stroke text-[40px]',
            className
          )}
        >
          <svg width="1em" height="1em" viewBox="0 0 50 50">
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="currentcolor"
              strokeWidth="4"
              strokeDasharray="97.6 28"
              strokeDashoffset="0"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      );
    }

    return (
      <div
        data-testid="loader"
        className={twMerge(
          'h-2.5 w-full shrink-0 animate-pulse rounded',
          styleClasses,
          rounded && 'rounded-full',
          className
        )}
      />
    );
  }

  return children;
};
